export const MISSION_STATUS_FILTER_TYPES = [
  'online',
  'suspended',
  'canceled',
  'interrupted',
];

export const MISSION_STATUS_FILTER_OPTIONS = [
  {
    type: 'online',
    name: 'En ligne',
    description: 'Visible par le candidat',
  },
  {
    type: 'suspended',
    name: 'Suspendue',
    description: 'Recrutement en pause',
  },
  {
    type: 'canceled',
    name: 'Annulée',
    description: 'Mission annulée avant son départ',
  },
  {
    type: 'interrupted',
    name: 'Interrompue',
    description: 'Mission en cours annulée',
  },
];

export const normalizeStatusSearch = (types = []) =>
  [...new Set(types.filter((type) => MISSION_STATUS_FILTER_TYPES.includes(type)))].sort();

export const parseStatusSearchParam = (statusParam) => {
  if (!statusParam) return [];
  return normalizeStatusSearch(statusParam.split(','));
};

export const migrateSavedStatusSearch = (saved = {}) => {
  if (Array.isArray(saved.statusSearch)) {
    return normalizeStatusSearch(saved.statusSearch);
  }

  if (Array.isArray(saved.missionStatus)) {
    return normalizeStatusSearch(saved.missionStatus);
  }

  return [];
};
